// src/components/Footer.jsx
import { Link } from 'react-router-dom';
import logo from '../assets/logos/logo.png'; 

function Footer() {
  return (
    <footer className="navbar-light bg-light py-4"> 
      <div className="container">
        <div className="row align-items-center">
          {/* Logo and Copyright */}
          <div className="col-md-4 d-flex align-items-center justify-content-center justify-content-md-start mb-3 mb-md-0">
            <Link className="navbar-brand d-flex align-items-center me-md-3" to="/">
              <img
                src={logo}
                alt="LI-YO & SONS logo"
                style={{ width: '40px', height: '40px', marginRight: '10px' }}
              />
            </Link>
            <p className="mb-0 small text-dark">© {new Date().getFullYear()} LI-YO & SONS GROUP(PTY) LTD</p>
          </div>

          {/* Website Developer Information */}
          <div className="col-md-4 text-center mb-3 mb-md-0">
            <p className="mb-0 small text-dark">
              Website Developed by <br />
             <a href="https://ilamitechnologies.com/" target="https://ilamitechnologies.com/" rel="noopener noreferrer" className="text-dark">www.ilamitech.com</a>
            </p>
          </div>

          {/* Footer Navigation Links */}
          <div className="col-md-4 text-center text-md-end">
    {/* Footer Nav Links */}
    <ul className="list-inline mb-3">
        <li className="list-inline-item">
            <Link className="nav-link text-dark small" to="/about">About</Link>
        </li>
        <li className="list-inline-item">
            <Link className="nav-link text-dark small" to="/services">Services</Link>
        </li>
        <li className="list-inline-item">
            <Link className="nav-link text-dark small" to="/contact">Contact</Link>
        </li>
    </ul>

    {/* Social Media Links */}
    <ul className="list-inline mb-0 social-icons"> 
        <li className="list-inline-item">
            <a href="https://www.facebook.com/profile.php?id=100001835045803&mibextid=wwXIfr&rdid=CJSOn4SZ0S4qGGRy&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F15dmsiEWdf%2F%3Fmibextid%3DwwXIfr#" target="_blank" rel="noopener noreferrer" className="text-dark">
                <i className="fab fa-facebook-f"></i> 
            </a>
        </li>
        <li className="list-inline-item">
            <a href="https://x.com/yonke_mlobeli?s=21&t=iBXGnEkLLVUKTWBeXvfYhg" target="_blank" rel="noopener noreferrer" className="text-dark">
                <i className="fab fa-x"></i> 
            </a>
        </li>
        <li className="list-inline-item">
            <a href="https://www.linkedin.com/in/yonke-m-ab0311a3/?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app" target="_blank" rel="noopener noreferrer" className="text-dark">
                <i className="fab fa-linkedin-in"></i> 
            </a>
        </li>
        <li className="list-inline-item">
            <a href="http://instagram.com/yonke_mlobeli/?igsh=a2h2ZGgwYmtramdz&utm_source=qr#" target="_blank" rel="noopener noreferrer" className="text-dark">
                <i className="fab fa-instagram"></i> 
            </a>
        </li>
    </ul>
</div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
